// =====================================================================
// Assessment Center — Student Login.
// Fields: Full Name, Email — no password on this flow, by design (see
// project README "Authentication" section). Registration (which does
// set a password) is one click away via "Create New Account".
// =====================================================================
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthShell from "./AuthShell";
import { Button, Field, Input } from "../../shared/components/ui";
import { useAuth } from "../../shared/auth/AuthContext";

export default function StudentLoginPage() {
  const { studentLogin } = useAuth();
  const navigate = useNavigate();
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await studentLogin({ fullName, email });
      navigate("/student/assessment-center");
    } catch (err) {
      setError(err instanceof Error ? err.message : "Couldn't sign you in.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AuthShell title="Student Login" subtitle="Enter your name and email to continue.">
      <form onSubmit={handleSubmit} className="space-y-4">
        <Field label="Full Name" required>
          <Input value={fullName} onChange={(e) => setFullName(e.target.value)} placeholder="Jordan Blake" required />
        </Field>
        <Field label="Email Address" required>
          <Input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            required
          />
        </Field>

        {error && <p className="text-sm text-red-600">{error}</p>}

        <Button type="submit" className="w-full" disabled={submitting}>
          {submitting ? "Continuing…" : "Continue"}
        </Button>
      </form>

      <div className="mt-6 border-t border-border-soft pt-5 text-center">
        <p className="text-sm text-slate-500">New here?</p>
        <Link to="/register/student">
          <Button variant="secondary" className="mt-3 w-full">
            Create New Account
          </Button>
        </Link>
      </div>
    </AuthShell>
  );
}
